export default __webpack_public_path__ + "static/media/mag1.5b505de6.svg";